<template>
  <ColumnWithHelp
    :min-width="130"
    sortable
    :resizable="false"
    :label="label"
    :title="$t('ADVERTISEMENT.BID.COLUMN_WIN_RATE')"
    :content="$t('ADVERTISEMENT.BID.COLUMN_DESC_WIN_RATE_CONTENT')"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template slot-scope="{ row: { winRate } }">
      %{{ priceFormat(winRate) }}
    </template>
  </ColumnWithHelp>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

export default {
  name: 'BidWinRateColumn',
  components: {
    ColumnWithHelp,
  },
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  methods: {
    priceFormat,
  },
};
</script>
